import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import LoginTemplate from './components/login-template.vue';
import moment from 'moment';
import VueCurrencyFilter from 'vue-currency-filter';
import VueMask from 'v-mask';
import CookieLaw from 'vue-cookie-law';
Vue.use(VueMask);

Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true,
  avoidEmptyDecimals: undefined,
});

Vue.config.productionTip = false;

Vue.component('doit-login-template', LoginTemplate);
Vue.component('cookie-law', CookieLaw);

Vue.filter('formatDate', (value: string) => {
  if (value) {
    return moment(value).format('MM/DD/YYYY');
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
